import { CounterLabel as PrimerCounterLabel, CounterLabelProps as PrimerCounterLabelProps } from '@primer/react';
import { PropsWithChildren } from 'react';

type Props = {} & PrimerCounterLabelProps;

const CounterLabel = ({ ...props }: PropsWithChildren<Props>) => <PrimerCounterLabel {...props} />;

export default CounterLabel;
export type { Props as CounterLabelProps };
